import { RowLayout } from '../../Vendors/VendorCreation/General/VendorForm/RowLayout'
import { FieldWithLabel } from '../../../../components/FieldWithLabel/FieldWithLabel'
import { LABELS } from '../../../../constants'
import { CommunityData } from '../../Communities/CommunityDetails/types'
import { IconFullName } from '../../../../components/IconFullName/IconFullName'
import { fullFormatPhoneNumber } from '../../../../helper/common'
import { onStartChat } from '../../utils'
import { QuickNavigationBlock } from '../QuickNavigationBlock'
import { ACTIONS, Can, SUBJECTS } from '../../../Permission'

export const CommunityDetails = ({
  communityData
}: {
  communityData: CommunityData
}) => {
  return (
    <div className="row gap-24">
      <div className="community-details">
        <RowLayout title="Business information">
          <div className="column">
            <FieldWithLabel title={LABELS.COMMUNITY_NAME}>
              {communityData?.name || '-'}
            </FieldWithLabel>
            <FieldWithLabel title={LABELS.DESCRIPTION} className="mt-24">
              {communityData?.description || '-'}
            </FieldWithLabel>
          </div>
        </RowLayout>
        <div className="separator mt-32 mb-32" />
        <RowLayout title="Community president">
          <IconFullName
            className="column"
            firstName={communityData?.contact_person?.first_name}
            lastName={communityData?.contact_person?.last_name}
            roleName={''}
            phone={fullFormatPhoneNumber(
              communityData?.contact_person?.phone_number || ''
            )}
            email={communityData?.contact_person?.email}
            src={communityData?.contact_person?.avatar_logo?.file_preview || ''}
            uuid={communityData?.contact_person?.uuid}
            onStartChat={onStartChat}
          />
        </RowLayout>
      </div>
      <Can I={ACTIONS.VIEW} a={SUBJECTS.QUICK_NAVIGATION_BLOCK}>
        <QuickNavigationBlock />
      </Can>
    </div>
  )
}
